import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { ReadingLevels } from "@/search/Langston/FilterPanel/filters/ReadingLevels/ReadingLevels";
import { ContentTypes } from "./ContentTypes";
import { filterContainerCss } from "./Filters.styles";
import { InstructionalFeature } from "./InstructionalFeature";
import { ReadingSkills } from "./ReadingSkills";
import { SortBy } from "./SortBy";
import { Standards } from "./Standards";
import { Concepts } from "./Concepts";

export const Filters = () => {
  const { isParent, isStudent } = useGetUserProperties();

  const canSeeStandardsFilter = !isStudent && !isParent;
  const canSeeTaxonomyFilter = !isStudent && !isParent;
  const canSeeReadingSkills = !isStudent && !isParent;
  const canSeeMaturityLevels = !isStudent && !isParent;

  return (
    <div css={filterContainerCss}>
      <ContentTypes />
      <SortBy />
      <ReadingLevels canSeeMaturityLevels={canSeeMaturityLevels} />
      <InstructionalFeature />
      {canSeeReadingSkills && <ReadingSkills />}
      {canSeeStandardsFilter && <Standards />}
      {canSeeTaxonomyFilter && <Concepts />}
    </div>
  );
};
